var _style, _path, _line, _line2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeparation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .separation-st0{fill:#FFFFFF;stroke:currentColor;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "separation-st0",
    d: "M333.6,37.4H180l0,0H26.4c-5.9,0-10.6,4.3-10.6,9.5V175l0,0v3.6c0,0.4,0,0.8,0.1,1.2 c2.9,79.3,75.3,142.7,164.2,142.7l0,0c88.9,0,161.3-63.5,164.2-142.7c0.1-0.4,0.1-0.8,0.1-1.2V175l0,0V46.9 C344.2,41.6,339.5,37.4,333.6,37.4z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20.8,
    y1: 214.6,
    x2: 338.4,
    y2: 214.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.3,
    y1: 229.2,
    x2: 332.9,
    y2: 229.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "separation-st0",
    x1: 180.1,
    y1: 10.2,
    x2: 180.1,
    y2: 214.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M349.4,46.7c-0.3-8-7.2-14.3-15.8-14.3H184.2V10.2h-8v22.2H26.4c-8.6,0-15.6,6.5-15.6,14.5v131.7c0,0.4,0,1.1,0.1,1.8 c1.6,39.7,19.9,76.7,51.5,104.3c31.7,27.6,73.5,42.8,117.6,42.8c44.1,0,85.9-15.2,117.6-42.9c31.7-27.6,50-64.6,51.5-104.2 c0.1-0.7,0.1-1.3,0.1-1.8V46.9L349.4,46.7z M20.8,178.6V46.9c0-2.4,2.6-4.5,5.6-4.5h149.8v168.2H25.8c-2.8-9.9-4.5-20.3-4.9-31 l0-0.5l-0.1-0.3C20.8,178.7,20.8,178.7,20.8,178.6z M180.1,317.5c-65.1,0-120.8-34.3-145.6-84.3h291.2 C300.9,283.2,245.2,317.5,180.1,317.5z M30.9,225.2c-0.9-2.2-1.7-4.3-2.5-6.6h303.5c-0.8,2.2-1.6,4.4-2.5,6.6H30.9z M339.3,179.1 l0,0.5c-0.4,10.7-2.1,21.1-4.9,31H184.2V42.4h149.4c3.1,0,5.7,2,5.8,4.6v131.6c0,0.1,0,0.1,0,0.2L339.3,179.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparation);
export default __webpack_public_path__ + "static/media/separation.86681ddd1d83958b06ba056d41604f34.svg";
export { ForwardRef as ReactComponent };